// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2DomG","title":"styles_title__3Qm5T"};